import axios from "axios"

interface itemInterface {
    colour:string
    inProduction:string
    name:string
    size:string
    sku:string
    stock:number
}

export const getStockData = async () => {
    try {
        const response = await axios.get(`${process.env.VUE_APP_STOCK_ENDPOINT}?api_key=${process.env.VUE_APP_API_KEY}`)
        const dataArray:itemInterface[] = Object.values(response.data)
        dataArray.forEach((item:itemInterface) => {
            console.log(item.inProduction)
            item.inProduction = (item.inProduction != null) ? item.inProduction.replaceAll("no date", "in production") : '' // the response needs altering to show as 'in produciton'
        })
        return { status: response.status, data: dataArray }
    } catch (error) {
        console.log(error)
        throw (error)
    }
}